import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { ThemeProvider as MaterialThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { A11ySettingsProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@a11y/A11ySettings/state/A11ySettingsProvider';
import { AlertProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Alert';
import { ModalProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal/providers/ModalProvider';
import TourProvider from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Tour/TourProvider';
import PageProvider from '@monorepo/shared/src/providers/PageProvider';
import defaultTheme from '@monorepo/shared/src/themes/defaultTheme';
import { AudioPlayerProvider } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/AudioManager';
import EditTeachingOrderProvider from './EditTeachingOrderProvider';
import AssignmentsProvider from 'state/providers/AssignmentsProvider';
import ClassroomProvider from './ClassroomProvider';
import { RouteGuardProvider } from 'state/hooks/use-route-guard';

const AppProviders: React.FC = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <MaterialThemeProvider theme={defaultTheme}>
          <A11ySettingsProvider>
            <AudioPlayerProvider>
              <ClassroomProvider>
                <PageProvider>
                  <AlertProvider>
                    <ModalProvider>
                      <RouteGuardProvider>
                        <EditTeachingOrderProvider>
                          <AssignmentsProvider>
                            <TourProvider>{children}</TourProvider>
                          </AssignmentsProvider>
                        </EditTeachingOrderProvider>
                      </RouteGuardProvider>
                    </ModalProvider>
                  </AlertProvider>
                </PageProvider>
              </ClassroomProvider>
            </AudioPlayerProvider>
          </A11ySettingsProvider>
        </MaterialThemeProvider>
      </QueryParamProvider>
    </StyledEngineProvider>
  );
};

export default AppProviders;
